<template>
    <Splide
        v-if="props.partners.length"
        :key="splideKey"
        :options="splideOptions">
        <SplideSlide
            v-for="partner in partnersFiltered"
            :key="partner.documentId">
            <a
                :href="partner.website"
                target="_blank">
                <v-img
                    class="tw-mx-auto tw-aspect-square tw-w-32 md:tw-w-44"
                    :src="useMedia(partner.image).medium"></v-img>
            </a>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { useMedia } from '@/composables/useMedia';
    import { Splide, SplideSlide } from '@splidejs/vue-splide';

    const props = defineProps<{
        partners: any[];
        sideways?: boolean;
    }>();

    const partnersFiltered = computed(() => {
        return props.partners.filter((partner) => partner.image);
    });

    const splideKey = computed(() => {
        return props.partners.map((partner) => partner.documentId).join('-');
    });

    const splideOptions = computed(() => ({
        focus: partnersFiltered.value.length > 6 || props.sideways ? undefined : 'center',
        type: 'slide',
        trimSpace: partnersFiltered.value.length > 6,
        perPage: 6,
        start: partnersFiltered.value.length > 6 || props.sideways ? 0 : Math.round(partnersFiltered.value.length / 2) - 1,
        perMove: 1,
        gap: '2rem',
        pagination: false,
        arrows: partnersFiltered.value.length > 6,
        autoplay: partnersFiltered.value.length > 6,
        rewind: true,
        interval: 2000,
        breakpoints: {
            1535: {
                perPage: 5,
                arrows: partnersFiltered.value.length > 5,
                autoplay: partnersFiltered.value.length > 5,
                gap: '2rem',
            },
            1200: {
                perPage: 3,
                arrows: partnersFiltered.value.length > 3,
                autoplay: partnersFiltered.value.length > 3,
                gap: '1rem',
            },
            640: {
                perPage: 2,
                perMove: 2,
                arrows: partnersFiltered.value.length > 2,
                autoplay: partnersFiltered.value.length > 2,
                gap: '1rem',
            },
        },
    }));
</script>

<style scoped></style>
